import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { Envelope, Pen, Person, Plus, Telephone, ChatLeftDots } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import CampaignContactModal from './CampaignContactParts/CampaignContactModal'
import Modal from '../../../../Modal/Modal'
import { useReadOnly } from '../../../../../contexts/ReadOnlyContext'

export default observer(function CampaignContacts() {
  const { campaignContacts } = useContext(CampaignContext)
  const readOnly = useReadOnly()
  const [campaignContactModalOpen, setCampaignContactModalOpen] = useState(false)
  const [edit, setEdit] = useState(false)
  const [editableContact, setEditableContact] = useState()
  const [index, setIndex] = useState()
  const [hover, setHover] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [note, setNote] = useState()

  const openNewCampaignContactModal = () => {
    setEditableContact()
    setEdit(false)
    setIndex()
    setCampaignContactModalOpen(true)
  }

  const openEditCampaignContactModal = (campaignContact, index) => () => {
    setEditableContact(campaignContact)
    setEdit(true)
    setIndex(index)
    setCampaignContactModalOpen(true)
  }

  const openNoteModal = (notes) => () => {
    console.log(notes)
    setNoteModalOpen(true)
    setNote(notes)
  }

  return (
    <div className="bg-white dark:bg-rb-dark-mode rounded-lg p-5 border-1 border-rb-widget-boarder dark:border-rb-dark-mode-lighter h-72">
      <div className="flex justify-between items-center mb-2">
        <p className="font-bold text-xl dark:text-white">Campaign Contacts</p>
        {!readOnly && <button className="flex items-center bg-rb-green text-white dark:text-rb-dark-mode p-1 px-2 rounded-md" onClick={openNewCampaignContactModal}><Plus/>Add new</button>}
      </div>

      <div className="overflow-y-auto" style={{ height: 'calc(100% - 4rem)' }}>
        { campaignContacts.map((campaignContact, index) => (
          <div key={campaignContact.id} className="grid grid-cols-12 mb-4 last:mb-0 items-center border-1 border-rb-widget-boarder dark:border-rb-dark-mode-lighter rounded-lg p-3">
            <div className="col-span-1">
              {campaignContact.avatar?.url && <img className="h-12 w-auto object-cover rounded-2xl" src={campaignContact.avatar.url} /> || <div className="h-12 w-12 bg-rb-green rounded-2xl text-white flex items-center justify-center border-1 border-white"><Person /></div>}
            </div>
            <div className="pl-4 col-span-10">
              <p className="text-sm font-bold dark:text-white">{campaignContact.name}</p>
              <div className="flex items-center">
                <p className="text-sm flex items-center mr-4 dark:text-gray-400"> <span className="text-rb-green dark:text-rb-green mr-1"><Envelope/></span> <span>{campaignContact.email}</span></p>
                <p className="text-sm flex items-center mr-4 dark:text-gray-400"><span className="text-rb-green dark:text-rb-green mr-1"><Telephone/></span><span>{campaignContact.phone}</span></p>
                {campaignContact.notes && (
                    <ChatLeftDots
                      className='text-rb-green dark:text-rb-green cursor-pointer'
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)}
                      onClick={openNoteModal(campaignContact.notes)}
                    />
                  )
                }
              </div>
            </div>
            {!readOnly && <button onClick={openEditCampaignContactModal(campaignContact, index)} className="col-span-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter w-10 h-10 flex items-center justify-center mr-4 dark:text-white"><Pen/></button>}
          </div>
        ))}
      </div>

      {
        noteModalOpen && (
          <Modal isOpen={noteModalOpen} onClose={() => setNoteModalOpen(false)}>
            <Modal.Body>
              <div className="w-80">
                <p style={{ fontStyle: 'italic' }}>{note}</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button className="bg-rb-green text-white p-2 px-3 rounded-md dark:text-rb-dark-mode" onClick={() => setNoteModalOpen(false)}>Close</button>
            </Modal.Footer>
          </Modal>
        )
      }
      <CampaignContactModal isOpen={campaignContactModalOpen} setIsOpen={setCampaignContactModalOpen} edit={edit} editableContact={editableContact} index={index} />
    </div>
  )
})
